import React, { Component, useRef, useState } from 'react';
import classNames from 'classnames';
import { VariableInput } from '../site';
import { ListBox, HelpImageViewer, HtmlComponent, SvgImage } from '.';
import { connect } from 'react-redux';
import { pinnedItemsState, pinnedItemDispatcher, currentNodeState, combineStates, siteSettingsState,dialogDispatcher } from '../store';
import { PropTypes } from 'prop-types';
import { CloseIconNew, CloseLightIconNew, MinusIconActive, OrangeWarningIconNew, ResetIconNew, VectorCounterMinusIcon, VectorCounterPlusIcon, VectorRightIconNew, closePopup, resetIcon } from '../../style/images';
import { Box, Dialog, Link, IconButton as MuiIconButton } from '@mui/material';
import { helpImage } from '../util';
import { translate } from '../services';
// import { useGesture } from 'd:/NewUi/abb/LPBS/Phase3/client/node_modules/@use-gesture/core/types/dist/use-gesture-core-types.cjs';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { combineDispatchers,popupDispatcher } from '../store';
import { SymbolTextModal } from './SymbolTextModal';


export const HelpImageContainer = ( {filterName, image, onClose, src } ) =>{
  // let [crop, setCrop] = useState({x:0, y:0});
  // let imageRef = useRef();
  // useGesture(
  //   {
  //     onDrag:({offset:[dx, dy]})=>{
  //       setCrop({x:dx, y:dy});
  //     },
  //   },
  //   {
  //     domTarget: imageRef
  //   }
  // )
  return <div className="help-image-container">
        <div className='help-image-header'>
          <div className='line'></div>
          <span className='heading'>{filterName}</span>
        </div>
          <TransformWrapper sx={{width:"100%", height:"100%"}} pinch={{ step: 0.1 }} minScale={1} maxScale={4} centerOnInit={false} doubleClick={{ disabled: true }}  >

            {({ zoomIn, zoomOut, resetTransform }) => (
              <div className='content-container'>
                 <TransformComponent wrapperClass="help-image-content" contentClass="help-image-content">
                   <img src={helpImage( image ) } alt={ image } />
                 </TransformComponent>
                 <div className='help-image-content-button-family'>
                    <Box component="img" className='round-button' src={VectorCounterPlusIcon} onClick={() => zoomIn()}></Box>
                    <Box component="img" className='round-button' src={MinusIconActive} onClick={() => zoomOut()}></Box>
                    <Box component="img" className='round-button' src={resetIcon} onClick={() => resetTransform()}></Box>
                </div>
              </div>
            )}
          </TransformWrapper>
        <div className='help-image-footer'>
            <div className='secondary-button' onClick={onClose}>
              <span>{translate("Okay")}</span>
            </div>
        </div>
  </div> ;

}
export class SelectionComponent extends Component {

  constructor( props ) {
    super( props );

    this.state = {
      expanded: false,
      showImage: false,
      image: null,
    };
  }

  onPinned( pinnedItem ) {
    const { groupName, identifier } = this.props;
    if ( this.isPinned( pinnedItem ) ) {
      this.props.removePinnedItem( groupName, identifier, pinnedItem.name );
    } else {
      this.props.setPinnedItem( groupName, identifier, pinnedItem.name );
    }
  }

  isPinned( item ) {
    const { groupName, identifier, pinnedItems } = this.props;
    return pinnedItems[groupName] 
        && pinnedItems[groupName][identifier] 
        && pinnedItems[groupName][identifier][item.name];
  }
  
  getMultiSelectSymbol() {
    const { multiselect } = this.props;
    if( multiselect === 'OR' ) {
      return '<b> OR</b>';
    }
    if( multiselect === 'AND' ) {
      return '<b> AND</b>';
    } 
    return '';
  }
  
  toggleExpanded = () => {
    const { expanded } = this.state;
    this.setState( { expanded: !expanded } );
  }

  setImage = (image)=>{
    this.setState({showImage:true, image:image})
  }
  closeImage = ()=>{
    this.setState({showImage:false})
  }
  openAllOptions=(data)=>{
    this.props.showDialog( 
      <SymbolTextModal  data={data}  onClick={this.props.onChange} onClose={this.props.closeDialog} cancelText={'Close'} actionText={'Apply'} selectedValueFromSelection={this.props.selectedValue}/>,
      {className:"Symbol-text-dialog-paper"}
      );
  }
  render() {
    const { groupName, pinnable, onChange,textField, valueField, predicate,selectedValue, showHelp, template, title, values, isBomItem, isRequired, disabled ,defaultFilter, customeFilteImageTitle, ShowAs, calculatedValue, value } = this.props;
    
    const className = classNames( { 'strong': values.any( value => this.props.isSelected( value ) || this.props.isDefault( value, values ) ) } );

    const listProps = {
      onChange: item => !disabled && this.props.onChange( item ), 
      isSelected: ( item, items ) => this.props.isSelected( item ) || this.props.isDefault( item, items ),
      isDefault: ( item, items ) => this.props.isDefault( item, items ),
      isForceable: ( item, items ) => this.props.isForceable( item, items ),
      isPinned: item => this.isPinned( item ),
      onItemPinned: item => this.onPinned( item ),
      disabled,
      pinnable,
      viewItem: template,
      isBomItem
    };
    
    const dialogBox = <Dialog open={this.state.showImage} sx={{width:"100%", height:"100%", padding:'32px'}} onClose={this.closeImage} PaperProps={{className:"help-image-dialog", sx:{
      display: 'inline-flex',
      // padding: "32px 24px",
      justifyContent: "center",
      alignItems: "center",
      gap: "24px",
      borderRadius: "4px",
      background: "#FFF",
      overflow:"hidden",
      margin:"0px",
      height:{md:"100%",xs:"max-content"},
      width:{md:"100%",xs:"max-content"},
      maxWidth:"100%",
      maxHeight: "100%"
    }}}>
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.closeImage} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: '24px', height: '24px'}} sx={{height:"16px", width:"24px"}}></Box>
            </MuiIconButton>
        {/* <Box component="img" src={closePopup} onClick={this.closeImage} sx={{fill:"#868686", width:"24px", height:"24px", position: "absolute",
          right: "12px",
          top: "12px"}}></Box> */}
                  <HelpImageContainer filterName= { title } image={ this.state.image } onClose={this.closeImage}/>  
    </Dialog>

    return <div className="selection">
      {/* <div className={ classNames( 'selection-header', { required: isRequired && values.none( v => v.isSelected ) } ) }> */}
      <div className={ classNames( 'selection-header', { required: isRequired && values.none( v => v.isSelected )} ) }>
        <Box sx={{width:{md:"100%",xs:"80%"}, height:"max-content", display:"flex", flexDirection:"column", gap:"4px"}}>
          <Box height="100%" sx={{width:{md:"100%",xs:"80%"}, display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"start", gap:'6px'}}>
            { isRequired && this.props.siteSettings.properties.showMandatoryWarning && values.none( v => v.isSelected )&&<Box component="img" src={OrangeWarningIconNew} sx={{width:'14px', height:'14px'}}></Box>}
            <HtmlComponent className={ className } tooltip={ title } item={ `${title}${this.getMultiSelectSymbol()}` } type="h3"/>
          </Box>
          <Box sx={{display:{md:"none", xs:"flex",
            padding: "4px 16px 16px 16px",
            alignItems: "flex-start",
            gap: "10px",
            alignSelf: "stretch",
            marginBottom: "-16px",
            marginLeft: "-16px"}}}>
            {showHelp && <HelpImageViewer selectorName={ groupName } defaultFilter={defaultFilter}  filterName= { title } displayName={ title } customeFilteImageTitle = {customeFilteImageTitle} image={this.state.image} setImage={this.setImage} mobileView={true} />}
          </Box>
        </Box>
        <Box sx={{display:{md:"none", xs:"flex"}}}>
          <SvgImage
                  source={ VectorRightIconNew } 
                  className={ classNames( 'expander', { 'expanded': this.state.expanded } ) } 
                  onClick={ this.toggleExpanded }
                />
        </Box>
        { showHelp &&<Box sx={{display:{md:"flex", xs:"none"}}}>
            <HelpImageViewer selectorName={ groupName } defaultFilter={defaultFilter}  filterName= { title } displayName={ title } customeFilteImageTitle = {customeFilteImageTitle} image={this.state.image} setImage={this.setImage} />
          </Box>}
      </div>
      <Box width="100%" className={classNames("selector-variable",{'configurator-filter-selection':ShowAs==="dropdown"})} height={{md:"calc(100% - 30px)", xs:"100%"}} sx={{display:{md:"flex", xs:this.state.expanded?"flex":"none"}}}>
        <VariableInput 
        multiple 
        showAs={ ShowAs? ShowAs : "select" }
        identifier = { this.props.identifier }
        textField = {textField}
        valueField = {valueField}
        type = { ShowAs === 'inputfield' && 'number'}
        disabled = { disabled } 
        data={ predicate ? values.filter( item => predicate( item ) ) : values } 
        listComponent={ ListBox } 
        listProps={ listProps }
        calculatedValue = { calculatedValue }
        value = { value }
        selectedValue = {selectedValue}
        placeholder_value = { 'Select...' }
        onChange = { onChange }
        fromSelector
        openAllOptions={this.openAllOptions}
      /> 
          {this.props.filter&&this.props.filter.properties.ShowAs?.toLowerCase()==="dropdown"&&this.props.filter.values.filter(value=>value.isSelected)[0]&&<div className="delete-icon">
              <SvgImage 
                source={ CloseLightIconNew }  
                toolTip={ translate( 'Remove assignment' ) }
                onClick={ this.props.removeAssigned }
              />
          </div>}
      </Box>
      {dialogBox}
    </div>;
  }
}

SelectionComponent.propTypes = {
  disabled: PropTypes.bool,
  groupName: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  isDefault: PropTypes.func.isRequired,
  isForceable: PropTypes.func.isRequired,
  isSelected: PropTypes.func.isRequired,
  multiselect: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  pinnable: PropTypes.bool,
  pinnedItems: PropTypes.shape( {} ).isRequired,
  predicate: PropTypes.func,
  removePinnedItem: PropTypes.func.isRequired,
  setPinnedItem: PropTypes.func.isRequired,
  showHelp: PropTypes.bool,
  template: PropTypes.oneOfType( [PropTypes.node, PropTypes.func] ).isRequired,
  title: PropTypes.string.isRequired,
  defaultFilter:PropTypes.string.isRequired,
  values: PropTypes.arrayOf( PropTypes.shape( {} ) ),
  isBomItem: PropTypes.bool
};

export const Selection = connect( combineStates( pinnedItemsState, currentNodeState, siteSettingsState), combineDispatchers( popupDispatcher,pinnedItemDispatcher,dialogDispatcher) )( SelectionComponent );